import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { getSenderUsage } from "../../helpers/stats_helper";

// Register ChartJS components
ChartJS.register(
  ArcElement,
  Title,
  Tooltip,
  Legend
);

// Function to generate a dynamic color based on index
const generateColor = (index) => {
  const hue = (index * 137.508) % 360; // Golden angle approximation for unique hues
  return `hsl(${hue}, 70%, 50%)`; // HSL with fixed saturation and lightness for consistency
};

const UserUsageChart = () => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        // Per-sender unit usage.
        const senders = await getSenderUsage();

        // Prepare data for the pie chart
        const labels = senders.map(s => s.name);
        const usageData = senders.map(s => parseInt(s.units) || 0);

        // Generate dynamic colors based on the number of users
        const backgroundColors = labels.map((_, index) => generateColor(index));
        const borderColors = backgroundColors.map(color => 
          color.replace('50%)', '60%)').replace('hsl(', 'hsl(') // Slightly darker border
        );

        setChartData({
          labels: labels,
          datasets: [{
            label: 'Units Consumed',
            data: usageData,
            backgroundColor: backgroundColors,
            borderColor: borderColors,
            borderWidth: 1,
          }]
        });
      } catch (err) {
        setError('Failed to load usage data');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  // Chart options for Pie
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Disable the legend
      },
      title: {
        display: true,
        text: 'Unit Consumption by Sender',
      },
    },
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!chartData) return null;

  return (
    <div style={{ width: '400px', margin: '0 auto' }}>
      <Pie data={chartData} options={options} />
    </div>
  );
};

export default UserUsageChart;